import { useIntersectionObserver } from '@vueuse/core'
import { ref } from 'vue'

/**
 * Like VueUse's `useElementVisibility`, but it disconnects after it's intersected once.
 * @param {Parameters<typeof useIntersectionObserver>[0]} target
 * @param {import('@vueuse/core').UseIntersectionObserverOptions=} options
 */
export default (target, options) => {
    const hasIntersected = ref(false)
    const { stop } = useIntersectionObserver(target, (([{ isIntersecting }]) => {
        if (!isIntersecting) return
        hasIntersected.value = true
        stop()
    }), options)
    return hasIntersected
}